import type { ReadonlyDeep } from 'type-fest';

import { CodingStrategyEnum } from '@e-socna/data-layer';
import type { Id } from '@e-socna/data-layer';

import { folderForm2ApiMapper } from './folder.form2api.mapper';
import type { FolderForm_Folder } from '../fragments/folder.fragment';

// The folder as the form holds it, coded automatically: its code may not be chosen yet.
export const folderDraftForm2ApiMapper = (
  folder: ReadonlyDeep<FolderForm_Folder>,
  automaticStrategyId: Id,
) =>
  folderForm2ApiMapper({
    ...folder,
    codingConfig: {
      __typename: CodingStrategyEnum.CodingConfigAutomatic as const,
      kind: CodingStrategyEnum.CodingConfigAutomatic,
      strategyId: automaticStrategyId,
    },
  });
